import './HoopsViewerDimensions.css';
import { jsx as d } from "react/jsx-runtime";
import $ from "clsx";
import { useMemo as n } from "react";
import { MM_IN_INCH as o } from "./HoopsViewer.consts.mjs";
const l = "_wrapper_eipax_1", F = {
  wrapper: l
}, y = (i) => {
  const { box: e, className: m } = i, s = Number((e == null ? void 0 : e.x) || 0), t = Number((e == null ? void 0 : e.y) || 0), r = Number((e == null ? void 0 : e.z) || 0), c = n(() => `${s.toFixed(1)} x ${t.toFixed(1)} x ${r.toFixed(1)} mm`, [s, t, r]), p = n(() => {
    const a = s / o, N = t / o, u = r / o;
    return `${a.toFixed(3)} x ${N.toFixed(3)} x ${u.toFixed(3)} in`;
  }, [s, t, r]);
  if (!e)
    return null;
  const x = `${p} | ${c}`;
  return /* @__PURE__ */ d("div", { className: $(F.wrapper, m), children: x });
};
export {
  y as H
};
//# sourceMappingURL=HoopsViewerDimensions-B3ECFNLG.js.map
